

























































































































































import { Component, Mixins } from "vue-property-decorator";
import Api from "@/api";
import swal from "sweetalert";
import FormErrorsMixin from "@/mixins/FormErrors";

import NavigationTabs from "@/components/Settings/Operator/NavigationTabs.vue";
import Table from "@/components/Common/Table.vue";
import AlertBox from "@/components/Common/Alerts/AlertBox.vue";
import Error404 from "@/components/Common/Error404.vue";
import { IOperator, IPagination, ITableParams } from "@/interface";
import { AxiosResponse } from "axios";

Component.registerHooks(["beforeRouteEnter", "beforeRouteUpdate"]);

@Component({
  components: {
    Table,
    NavigationTabs,
    AlertBox,
    Error404
  }
})
export default class AdditionalOperators extends Mixins(FormErrorsMixin) {
  public loading = false;
  public updating = false;
  private operators: Array<IOperator> = [];
  private noDataExist = false;
  private selectedOperator: IOperator | null = null;
  private selectedOperatorId: string | null = null;
  private failedRequest = false;
  private metaData: ITableParams | null = null;
  private fetchParams: IPagination = {
    page: 1,
    per_page: null,
    to: 1,
    search: ""
  };
  private componentKey = 0;

  private beforeRouteEnter(to: any, from: any, next: any): void {
    next((vm: this) => {
      vm.selectedOperatorId = vm.$route.params.id;
      vm.getOperators(() => {
        vm.getOperator(() => {
          //
        });
      });
    });
  }

  private beforeRouteUpdate(to: any, from: any, next: any): void {
    if (to.query.operator_deleted === "true") {
      swal("Success!", "The operator was deleted.", "success").then(() => {
        window.history.pushState({}, document.title, window.location.pathname);
      });
    }
    this.forceRerender();
    if (
      this.fetchParams.per_page !== null &&
      this.fetchParams.per_page !== undefined &&
      this.fetchParams.to !== null &&
      this.fetchParams.to !== undefined &&
      this.fetchParams.page !== undefined &&
      this.fetchParams.to % this.fetchParams.per_page === 0 &&
      this.fetchParams.page !== 1
    ) {
      this.fetchParams.page -= 1;
    }
    this.getOperators(() => {
      this.getOperator(() => {
        //
      });
    });
    next();
  }

  private getOperators(successCallback?: any): void {
    const endpoint: string = this.$partnerEndpoint("operators");

    Api()
      .get(endpoint, {
        params: {
          page: this.fetchParams.page,
          search: this.fetchParams.search
        }
      })
      .then((response: AxiosResponse) => {
        this.operators = response.data.data;
        this.metaData = response.data.meta;
        this.failedRequest = false;
        if (typeof successCallback == "function") {
          successCallback();
        }
      })
      .catch((error: any) => {
        console.log(error);
      });
  }

  private createOperator(): void {
    const endpoint: string = this.$partnerEndpoint("operators");

    Api()
      .post(endpoint)
      .then((response: AxiosResponse) => {
        this.selectedOperatorId = response.data.data.id;
      })
      .catch((error: any) => {
        console.log(error);
      });
  }

  private getOperator(successCallback?: any): void {
    if (this.loading) {
      return;
    }

    this.loading = true;
    const endpoint: string = this.$partnerEndpoint(
      "operators/" + this.selectedOperatorId
    );

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        this.selectedOperator = response.data.data;

        if (typeof successCallback == "function") {
          successCallback();
        }
      })
      .catch((error: any) => {
        if (error.response.status === 404) {
          this.noDataExist = true;
        }
        this.storeErrors(error.response.data.errors);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private deleteOperator(operatorId: number): void {
    if (this.loading || this.updating) {
      return;
    }

    swal({
      title: "Are you sure?",
      text: "The operator will be deleted",
      icon: "warning",
      dangerMode: true,
      buttons: {
        cancel: {
          visible: true,
          text: "Cancel",
          closeModal: true
        },
        confirm: {
          visible: true,
          text: "Yes, delete it!",
          closeModal: true
        }
      }
    }).then(isConfirm => {
      if (isConfirm) {
        const endpoint = this.$partnerEndpoint("operators/" + operatorId);

        Api()
          .delete(endpoint)
          .then(() => {
            this.$router.push({
              name: "AdditionalOperators",
              query: {
                operator_deleted: "true"
              }
            });
          })
          .catch((error: any) => {
            if (error.response.status === 403) {
              swal({
                title: "Missing permission",
                text: "You are not allowed to delete operators.",
                icon: "error"
                //dangerMode: true,
              });
            }
          });
      } else {
        //
      }
    });
  }

  private forceRerender(): void {
    this.componentKey += 1;
  }

  get operatorName(): string {
    if (typeof this.operators == "undefined") {
      return "";
    }

    if (this.selectedOperatorId === "default" && this.selectedOperator) {
      return this.selectedOperator.name || "";
    }

    for (var i = 0; i < this.operators.length; i++) {
      if (this.operators[i].id == this.selectedOperatorId) {
        return this.operators[i].name || "";
      }
    }

    return "";
  }
}
